import { Col, Row } from "antd";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { CalendarOutlined } from "@ant-design/icons";
import { startGetAsistencia } from "../../context/actions/asistenciasActions";
import { dateFromString } from "../../utils/dateFromString";
import { EsCita } from "./EsCita";
import { FechaRowAsignacion } from "./FechaRowAsignacion";
import { LocalCarretero } from "./LocalCarretero";
import { ModalDetalle } from "./modalDetalle/ModalDetalle";

export const TablaItem = () => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const { asistencias } = useSelector((state) => state.asistenciasReducer);
  const rowClick = (asistenciaID) => {
    setOpen(true);
    dispatch(startGetAsistencia(asistenciaID));
  };

  if (asistencias.length === 0) {
    return (
      <div style={{ textAlign: 'center', padding: '60px 20px', color: '#999' }}>
        <CalendarOutlined style={{ fontSize: '48px', color: '#d9d9d9', marginBottom: '16px' }} />
        <div style={{ fontSize: '14px', lineHeight: '1.6' }}>
          Seleccione un rango de fechas y haga clic en <strong>Filtrar</strong>
          <div style={{ fontSize: '12px', color: '#bbb', marginTop: '8px' }}>
            Máximo 30 días
          </div>
        </div>
      </div>
    );
  }

  return (
    <>
      {asistencias.map((a, i) => (
        <Row
          gutter={10}
          onClick={() => rowClick(a.asistenciaID)}
          key={i}
          style={{
            textDecoration: a.fechaCancelacion ? 'line-through' : 'none'
          }}
          className="rowAsistencias"
        >
          <Col span={2} className="rowNormalTabla">
            {a.asistenciaID}
          </Col>
          <Col span={2} className="rowNormalTabla">
            <div className="rowFechaTabla">
              {dateFromString(a.fechaCapturaTerminada).dateStep}
            </div>
          </Col>
          <Col span={2} className="rowNormalTabla">
            <FechaRowAsignacion asistencia={a} />
          </Col>
          <Col span={2} className="rowNormalTabla">
            <div className="rowFechaTabla">
              {dateFromString(a.fechaArribo).soloHora || "-"}
            </div>
          </Col>
          <Col span={2} className="rowNormalTabla">
            <div className="rowFechaTabla">
              {dateFromString(a.fechaConcluido).dateStep}
            </div>
          </Col>
          <Col span={3} className="rowNormalTabla">
            {a.titular}
          </Col>
          <Col span={3} className="rowNormalTabla">
            {a.servicio}
          </Col>
          <Col span={1} className="rowNormalTabla">
            <EsCita esCita={a.esCita} />
          </Col>
          <Col span={2} className="rowNormalTabla">
            <LocalCarretero localCarretero={a.localCarretero} />
          </Col>
          <Col span={3} className="rowNormalTabla">
            {a.origen}
          </Col>
          <Col span={2} className="rowNormalTabla">
            <div className="rowFechaTabla">
              {dateFromString(a.fechaCancelacion).dateStep}
            </div>
          </Col>
        </Row>
      ))}
      <ModalDetalle open={open} setOpen={setOpen} />
    </>
  );
};
